import { Modal } from "antd";
import { defineMessages, IntlShape } from "react-intl";

import styles from "./FieldUniqueConfirmModal.module.scss";

const messages = defineMessages({
  cancel: {
    id: "settings.manageFields.createEditPane.showFieldUniqueConfirmModal.cancel",
    defaultMessage: "Cancel",
    description: "Cancel button",
  },
  confirmTitle: {
    id: "settings.manageFields.createEditPane.showFieldUniqueConfirmModal.confirmTitle",
    defaultMessage: "Are you sure?",
    description: "Confirm modal title",
  },
  continue: {
    id: "settings.manageFields.createEditPane.showFieldUniqueConfirmModal.continue",
    defaultMessage: "Continue",
    description: "Continue button",
  },
  errorText: {
    id: "settings.manageFields.createEditPane.showFieldUniqueConfirmModal.errorText",
    defaultMessage:
      "To mark this field as unique, update any existing records with duplicate values to ensure all values are unique. Then, come back and try again.",
    description: "Error modal content",
  },
  errorTitle: {
    id: "settings.manageFields.createEditPane.showFieldUniqueConfirmModal.errorTitle",
    defaultMessage: "Field cannot be marked as unique until all existing values are unique",
    description: "Error modal title",
  },
  okay: {
    id: "settings.manageFields.createEditPane.showFieldUniqueConfirmModal.okay",
    defaultMessage: "Okay",
    description: "Okay button",
  },
});

const showFieldUniqueConfirmModal = (intl: IntlShape) => {
  return Modal.error({
    cancelText: intl.formatMessage(messages.cancel),
    className: styles.modal,
    content: intl.formatMessage(messages.errorText),
    okText: intl.formatMessage(messages.okay),
    onOk: undefined,
    title: intl.formatMessage(messages.errorTitle),
  });
};

export default showFieldUniqueConfirmModal;
